import styled from 'styled-components';

// Stripe css syntax
export const inputStyle = {
  base: {
    fontFamily: 'UtopiaStd-Regular, Poppins, Helvetica, sans-serif',
    color: '#35447d',
    fontSize: '20px',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#35447d',
    },
  },
  invalid: {
    color: '#ef3f39',
  },
};

export const loaderStyle = {
  position: 'absolute',
  height: '15rem',
  width: 'auto',
  left: 0,
  right: 0,
  margin: '0 auto',
  bottom: '40%',
};

export const wrapperStyle = {
  borderBottom: '1px solid #35447d',
  height: '42px',
  marginBottom: '2rem',
  padding: '0.9rem 0',
};

export const ButtonWrapper = styled.button`
  align-items: center;
  align-self: center;
  background: #8AEBF1;
  border: none;
  cursor: pointer;
  display: flex;
  font-family: Helvetica, sans-serif;
  font-size: 1.6rem;
  height: 4.5rem;
  justify-content: space-between;
  margin-left: auto;
  margin-top: 4rem;
  padding: 0 2rem;
  width: 25rem;

  .caption {
    color: #35447d;
    margin: 0;
  }
  img {
    width: 1.7em;
    height: 1.7em;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/BeginPage/Stripe/StripeStyles.js